import {getClassAssistClassContent} from '@/content/classAssist'
import type {TFunction} from '@/i18n'

// "Class 25 - Clothing, footwear, headgear", as the class-assist lists name a class
export const getClassLabel = (
  t: TFunction,
  classNames: Record<number, string>,
  classCode: string,
) => {
  const {classTitle} = getClassAssistClassContent(classCode)
  return `${t(classTitle)} ${classCode} - ${classNames[Number(classCode)]}`
}
